import { InventoryItemType } from 'src/app/core/enums/inventory-item-type.enum';

export type GoodsStatusFilter =
  | ''
  | 'active'
  | 'blocked'
  | 'archived'
  | 'all';

export type GoodsStockFilter = '' | 'in' | 'out';

export type GoodsSourceFilter = '' | 'bc' | 'local';

export type GoodsTypeFilter = '' | InventoryItemType;

export type GoodsIsCompositeFilter = '' | 'composite' | 'simple';

export interface GoodsFilterModel {
  categoryId: string;
  type: GoodsTypeFilter;
  status: GoodsStatusFilter;
  stock: GoodsStockFilter;
  source: GoodsSourceFilter;
  isComposite: GoodsIsCompositeFilter;
}

export const GOODS_FILTER_FIELDS = {
  CategoryId: 'categoryId',
  Type: 'type',
  Status: 'status',
  Stock: 'stock',
  Source: 'source',
  IsComposite: 'isComposite',
} as const;

export function createEmptyGoodsFilterModel(): GoodsFilterModel {
  return {
    categoryId: '',
    type: '',
    status: '',
    stock: '',
    source: '',
    isComposite: '',
  };
}

export interface GoodsCategoryOptionViewModel {
  id: string;
  title: string;
}
